/* pk-prefetch — warm same-origin page HTML on hover / tap / focus intent so
   navigations feel instant. Dependency-free (~1KB). Skips cart/account/checkout,
   cross-origin, downloads, new-tab links, and data-saver connections. */
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var prefetched = new Set();
  var hoverTimer;

  function warm(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function target(el) {
    var a = el && el.closest ? el.closest('a[href]') : null;
    if (!a || a.hasAttribute('download') || a.target === '_blank' || a.rel === 'nofollow') return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;          // same-origin only
    if (u.pathname === location.pathname) return null;      // not the current page
    if (/^\/(cart|account|checkout)(\/|$|\?)/.test(u.pathname)) return null;
    return u.href;
  }

  // hover: prefetch after a short intent delay (cancel if the pointer leaves)
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var href = target(e.target);
    if (!href) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { warm(href); }, 60);
  }, { capture: true, passive: true });
  document.addEventListener('pointerout', function () { clearTimeout(hoverTimer); }, { capture: true, passive: true });

  // touch / keyboard: strong intent, prefetch immediately
  document.addEventListener('touchstart', function (e) { var h = target(e.target); if (h) warm(h); }, { capture: true, passive: true });
  document.addEventListener('focusin', function (e) { var h = target(e.target); if (h) warm(h); }, { capture: true, passive: true });
})();
